/*
	@description:
	Main application definition, the application is just a jquery clone to use
	as dispatcher
*/
var $ = (!$ ? jQuery : $);
var ss = !ss ? {} : ss;

